import React from 'react';
import TransactionHistory from '../components/resuableComponents/TransactionHistory';

const Transaction = () => {
	return (
		<div>
			<TransactionHistory />
		</div>
	);
};

export default Transaction;
